import { Link } from "react-router-dom";
import { emergencyServices } from "@/mocks/siteContent";
import { buildEmergencyDirectoryHref } from "@/utils/emergency";
import useReveal from "@/hooks/useReveal";

export default function EmergencyServiceGrid() {
  const reveal = useReveal<HTMLDivElement>(0.05);

  return (
    <div ref={reveal.ref} className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
      {emergencyServices.map((service, index) => (
        <Link
          key={service.id}
          to={buildEmergencyDirectoryHref(service)}
          title={`${service.label} listings — ${service.description}`}
          className={`group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-red-300 hover:bg-red-50/60 ${
            reveal.visible ? "animate-fade-up" : "opacity-0"
          }`}
          style={{ animationDelay: `${index * 45}ms` }}
        >
          <span className="flex h-11 w-11 items-center justify-center rounded-md border border-red-100 bg-red-50 text-red-600 transition-colors group-hover:bg-red-100">
            <i className={`${service.icon} text-xl`} />
          </span>
          <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">
            {service.label}
          </h3>
          <p className="mt-1 text-xs leading-relaxed text-foreground-500">{service.description}</p>
          <span className="mt-3 inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-red-600">
            View listings
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-arrow-right-line text-sm transition-transform duration-200 group-hover:translate-x-0.5" />
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}